import { PropTypes } from 'prop-types'
import { Element } from '../../html/element'
import classes from './index.module.scss'
import { LegendItem } from './LegendItem'

export const Legend = ({
  chartId,
  items,
  className,
  style,
  listCheckBox,
  setListCheckBox,
  onCheckbox,
}) => {
  return (
    <Element className={[className, classes.container].join(' ')} style={style}>
      {items.map((item, index) => (
        <LegendItem
          key={[item.color, index].join('-')}
          chartId={chartId}
          setListCheckBox={setListCheckBox}
          listCheckBox={listCheckBox}
          onCheckbox={onCheckbox}
          {...item}
        />
      ))}
    </Element>
  )
}

Legend.propTypes = {
  chartId: PropTypes.string,
  items: PropTypes.array.isRequired,
  className: PropTypes.string,
  style: PropTypes.object,
}

Legend.defaultProps = {
  items: [],
}
